import { useVibeModeDockAvailability } from '@/modules/VibeMode/hooks/useVibeModeDockAvailability';
import {
    getVibeModeDockChannel,
    VIBE_MODE_DOCK_WIDTH_PX
} from '@/modules/VibeMode/vibe-mode-dock.contract';

export const useVibeModeDock = () => {
    const { isOpen } = getVibeModeDockChannel().useChannelState();
    const { isDockAvailable } = useVibeModeDockAvailability();

    return {
        isDockOpen: isDockAvailable && isOpen,
        dockWidth: VIBE_MODE_DOCK_WIDTH_PX
    };
};
